import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import { approvvendor, vendorrequestlist } from "../../service/Mainservice";

const VrequestList = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await vendorrequestlist();
      setData(response.data.data);
    } catch (error) {
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAccept = async (id) => {
    try {
      const params = { storeId: id, action: "approve", notes: "" };
      const response = await approvvendor(params);
      setOpen(true);
      setMsg(response.data.message);
      getData();
    } catch (error) {
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handleReject = async (id) => {
    try {
      const params = { storeId: id, action: "reject", notes: "" };
      const response = await approvvendor(params);
      setOpen(true);
      setMsg(response.data.message);
      getData();
    } catch (error) {
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Store Approvals</h1>
        </div>
        {data.length > 0 ? (
          <div className="data_table_over">
            <table className="data_table">
              <thead>
                <tr>
                  <th>Vendor</th>
                  <th>Mobile Number</th>
                  <th>Email</th>
                  <th>Business License</th>
                  <th>Documents</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id}>
                    <td className="user_name">
                      {item.image ? (
                        <img
                          src={item.image}
                          alt="profile"
                          className="data_userdetails_img"
                        />
                      ) : (
                        <div className="data_userdetails_img">
                          <PersonOutlineIcon />
                        </div>
                      )}
                      {item.fullName}
                    </td>
                    <td>{item.mobileNumber}</td>
                    <td>{item.email}</td>
                    <td>
                      {item.businessLicense ? (
                        <a
                          href={item.businessLicense}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View License
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      {item.documents ? (
                        <a
                          href={item.documents}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View Documents
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      <div className="action_button">
                        <button
                          className="active_user"
                          onClick={() => handleAccept(item.id)}
                        >
                          Accept
                        </button>
                        <button
                          className="block_user"
                          onClick={() => handleReject(item.id)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="nodata">No Store requests available</p>
        )}
        <Snackbar
          open={open}
          autoHideDuration={4000}
          onClose={() => setOpen(false)}
        >
          <Alert variant="filled" severity="success">
            {msg}
          </Alert>
        </Snackbar>
      </div>
      {loading && <Loader />}
    </>
  );
};

export default VrequestList;
